export default __webpack_public_path__ + "static/media/eclipse-banner-image.41423d67.png";